<template>
  <section class="component-adjustment">
    <app-loading :isFull="true" v-if="isLoading" />
    <b-table stacked="lg" :fields="fieldsItems" :items="earnList" class="font-14 text-center">
      <template v-slot:cell(date)="row" >
        <p class="mb-0">{{row.item.date | date}}</p>
      </template>
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.paid ? 'تسویه شده' : 'در حال بررسی' }}</p>
      </template>
      <template v-slot:cell(amount)="row" >
        <p class="mb-0">{{row.item.amount | currency}}</p>
      </template>
    </b-table>
    <page-number :lengthList="lengthList" @callBack="getEarn" />
  </section>
</template>

<script>
export default {
  name: 'component-adjustment',
  data () {
    return {
      isLoading: false,
      fieldsItems: [
        { key: 'course_title', label: 'نام دوره' },
        { key: 'date', label: 'تاریخ فروش' ,sortable: true},
        { key: 'amount', label: 'مبلغ پرداختی',sortable: true },
        { key: 'offerCodeText', label: 'کد تخیف' },
        { key: 'offerPercent', label: 'درصد تخفیف',sortable: true },
        { key: 'teacher_percentage', label: 'درصد مدرس',sortable: true },
        { key: 'teacher_portion', label: 'در آمد مدرس' ,sortable: true},
        { key: 'user_fullname', label: 'نام خریدار' }
      ]
    }
  },
  computed: {
    earnList () {
      return this.$store.state.Daccounting.myEarnList
    },
    lengthList () {
      return this.$store.state.Daccounting.myEarnListlengths
    }
  },
  methods: {
    async  getEarn (p) {
      this.isLoading = true
      await this.$store.dispatch('Daccounting/getMyEarnList', {p})
      this.isLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard-component/my-payment/adjustment.vue